import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { UserSearchComponent } from './components/user-search/user-search.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserPasswordComponent } from './components/user-password/user-password.component';

const userRoutingModule: Routes = [
  {
    path: 'user/list',
    component: UserSearchComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Usuários',
      roles: 'A'
    },
  },
  {
    path: 'user/edit',
    component: UserDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Edição de Usuário',
      roles: 'A'
    }
  },
  {
    path: 'user/add',
    component: UserDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Novo Usuário',
      roles: 'A'
    }
  },
  {
    path: 'user/pass',
    component: UserPasswordComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Troca de Senha',
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(userRoutingModule, { useHash: true })
  ],
  exports: [
    RouterModule
  ],
})

export class UserRoutingModule { }
